module.exports = __webpack_public_path__ + "static/media/Fuse.8233e52c.svg";